"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectStatus = void 0;
var title_case_1 = require("../../utils/title-case");
var lodash_1 = require("lodash");
var entity_select_transform_1 = require("../../utils/entity-select-transform");
exports.ProjectStatus = {
  name: 'ProjectStatus',
  label: 'Activity Status',
  pluralLabel: 'Activity Statuses',
  type: "taxonomy",
  select: {
    transform: function (entity, context) {
      var _a, _b, _c;
      return __assign(__assign({}, (0, entity_select_transform_1.entitySelectTransform)(entity, context)), {
        // @ts-ignore
        icon: context.icons.ProjectStatus[(0, title_case_1.titleCase)(entity.slug)] || context.icons.ProjectStatus.NotStarted,
        color: ((_a = context.theme.light) === null || _a === void 0 ? void 0 : _a.color.projectStatus) && (((_b = context.theme.light) === null || _b === void 0 ? void 0 : _b.color.projectStatus[(0, lodash_1.camelCase)(entity.slug)]) || ((_c = context.theme.light) === null || _c === void 0 ? void 0 : _c.color.projectStatus.notStarted))
      });
    }
  }
};